import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';

const CreditModal = ({ userData, callback }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const submit = async () => {
        if (document.getElementById("amount").value) {
            let postData = {
                "userId": userData?._id,
                "amount": document.getElementById("amount").value?.trim()
            }
            let resp = await postApi(postData, urlApi.creditRewardToUser);
            if (resp.responseCode === 200) {
                toast.success(resp.message);
                if (callback) {
                    callback();
                }
                handleClose();
            } else {
                toast.error(resp.message);
            }
        } else {
            toast.error("Please enter amount");
        }
    }

    return (
        <>
            <button className='bg-green-600 !px-5 !py-1.5 rounded-full text-sm text-white' onClick={handleShow}>Credit</button>
            <Modal show={show} onHide={handleClose} backdrop={'static'}>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold"> Credit To {userData?.name}</p>
                        <IconX className='cursor-pointer' color='white' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="flex flex-col gap-1">
                        <label htmlFor="amount" className='font-medium'>Amount</label>
                        <input type="text" id='amount' placeholder="Amount" className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='px-4 py-1 bg-[var(--secondary)] text-white text-sm font-semibold rounded-lg' onClick={handleClose}>Cancel</button>
                        <button className='px-4 py-1 bg-[var(--secondary-gradient-1)] text-white text-sm font-semibold rounded-lg' onClick={() => submit()}>Submit</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreditModal